// extracted by mini-css-extract-plugin
export var articles = "recipe-section-module--articles--527d9";
export var articles_container = "recipe-section-module--articles_container--025e5";
export var bar = "recipe-section-module--bar--6e57e";